import {
    ValidatorFn,
    AbstractControl} from "@angular/forms";

export function alphaValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const controlValue = control.value;
        if (controlValue) {
            if (/^[A-Z]+$/i.test(controlValue))
                return null;
            else
                return { 'alpha': null };
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@rx/forms/validator/validators/alpha.validator.ts